import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { DatePipe, Location } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectorRef,
  OnDestroy,
  ViewChild,
  Output,
  EventEmitter,
  Input,
  SimpleChanges,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { FilterByPipe, OrderByPipe } from 'ngx-pipes';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject, of, concat, Subscription } from 'rxjs';
import {
  filter,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  catchError,
  tap,
  map,
} from 'rxjs/operators';
import Swal from 'sweetalert2';

import { AuthService } from '@app/core/auth';
import { ClientService } from '@app/core/client/services/client.service';
import { PipelineService } from '@app/core/pipelines/services/pipeline.service';
import { ProductTagService } from '@app/core/product-tags/services/product-tag.service';
import { CategoryService } from '@app/core/products/services/category.service';
import { SubCategoryService } from '@app/core/products/services/subcategory.service';
import { RfqService, RFQ } from '@app/core/quotes';
import { CardSubtaskService } from '@app/core/quotes/services/card-subtask.service';
import { ProductDesignService } from '@app/core/quotes/services/product-design.service';
import { SettingsService } from '@app/core/settings/services/settings.service';
import { StaffService } from '@app/core/staff';
import { environment } from '@app/env-service';
import { UIStateService } from '@app/shared/services/ui-state.service';

import { NdPipelinePopupComponent } from '../nd-pipeline-popup/nd-pipeline-popup.component';
import { NdPopupFormComponent } from '../nd-popup-form/nd-popup-form.component';
import { NdViewCardPopupComponent } from '../nd-view-card-popup/nd-view-card-popup.component';

@Component({
  selector: 'cnc-nd-pipeline-view',
  templateUrl: './nd-pipeline-view.component.html',
  styleUrls: ['./nd-pipeline-view.component.scss'],
  providers: [FilterByPipe, DatePipe, OrderByPipe],
})
export class NdPipelineViewComponent implements OnInit, OnDestroy {
  url :string = environment.url;

  initialize :boolean = false;
  pipelineStatus :any[] = [];
  records :any = {};

  minLengthTerm = 3;

  searchKey :string = '';

  filter :any = {};
  pipelineFilter :any = {};
  checked :any = [];
  showFilter :boolean = false;
  checkedAll :boolean = false;
  loadingPipelines :boolean = false;

  pipelines :any[] = [];
  masterPipelines :any[] = [];
  childPipelines :any[] = [];
  activePipeline :any;
  activeMasterPipeline :any;

  subscription :Subscription;
  designSubscription :Subscription;

  goTeam :any[] = [];
  goStaff :any[] = [];
  staff :any[] = [];

  addingDesign :boolean;
  productDesigns$ :Observable<any[]>;
  designLoading = false;
  designInput$ = new Subject<string>();
  productDesign :any;

  subscriptions :Subscription[] = [];

  valid_format :any[] = ['jpeg', 'jpg', 'png', 'bmp', 'ico', 'icon', 'gif', 'svg'];

  @Output() changePipeline = new EventEmitter<any[]>();
  @Input() newDesign :any;

  JSON :JSON;

  constructor(
    public authService :AuthService,
    public settingsSvc :SettingsService,
    private router :Router,
    private ref :ChangeDetectorRef,
    private modal :NgbModal,
    private translate :TranslateService,
    public pcatService :CategoryService,
    public staffService :StaffService,
    public clientSvc :ClientService,
    private uiStateSvc :UIStateService,
    private toastr :ToastrService,
    public pipelineSvc :PipelineService,
    public productDesignSvc :ProductDesignService,
    private activeRoute :ActivatedRoute,

    private filterBy :FilterByPipe,
    private datePipe :DatePipe,
    private orderBy :OrderByPipe,
    public tagSvc :ProductTagService,
    private subtaskSvc :CardSubtaskService,
    public subcategorySvc :SubCategoryService,
    private location :Location,
  ) {
    this.JSON = JSON;
  }

  ngOnChanges(changes :SimpleChanges) {
    for (const property in changes) {
      if (property === 'newDesign') {
        if (
          changes[property].currentValue &&
          (!changes[property].previousValue ||
            changes[property].currentValue.id != changes[property].previousValue.id)
        ) {
          this.addNewDesignToPipelines(changes[property].currentValue);
        }
      }
    }
  }

  addNewDesignToPipelines(newDesign) {
    newDesign.pipelines.forEach((pipeline :any) => {
      const viewPipeline :any = this.pipelines.find(
        (row) => row.id == pipeline.pipeline_id,
      );
      if (viewPipeline) {
        viewPipeline.stages[0].records.splice(0, 0, newDesign);
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.designSubscription.unsubscribe();
    this.subscriptions.forEach((sub) => {
      sub.unsubscribe();
    });
  }

  ngOnInit() {
    this.initialize = true;
    const stateView = this.uiStateSvc.getState('design-sku-pipelines');
    if (stateView) {
      this.filter = stateView;
    }
    this.initialize = false;

    this.tagSvc.getTags({ parent_only: true }, null);

    this.staffService.getAllAssignee().subscribe((staff :any) => {
      this.staff = staff['records'];
      this.staff.forEach((element) => {
        element.name = element.firstname + ' ' + element.lastname;
      });
    });

    // get pipelines
    this.loadingPipelines = true;
    this.subscription = this.pipelineSvc.pipelines$.subscribe((pipelines) => {
      if (pipelines && pipelines.data) {
        // this.pipelines = pipelines.data.filter((row) => row.pipeline_type == 2);
        this.pipelines = pipelines.data;
        this.masterPipelines = this.filterBy.transform(
          this.pipelines,
          ['pipeline_type'],
          2,
        );
        if (!this.filter.masterPipelineId && this.masterPipelines.length > 0) {
          this.filter.masterPipelineId = this.masterPipelines[0].id;
        }
        if (this.masterPipelines.length > 0) {
          let masterIds = this.masterPipelines.map((row) => row.id);
          this.masterPipelines.forEach((mp) => {
            masterIds = masterIds.concat(
              mp.child_pipelines.map((row) => row.pipeline_id),
            );
          });
          const unAssignedPipelines = this.pipelines.filter(
            (row) => masterIds.indexOf(row.id) === -1,
          );
          if (unAssignedPipelines.length > 0) {
            const unAssignedMasterPipeline = {
              id: -1,
              child_pipelines: unAssignedPipelines.map((p, idx) => {
                return {
                  pipeline: p,
                  pipeline_id: p.id,
                  master_pipeline_id: -1,
                  order: idx,
                };
              }),
              label: 'Un-assigned Pipelines',
              pipeline_type: 2,
            };
            this.masterPipelines.push(unAssignedMasterPipeline);
          }

          this.setMasterPipeline();
        }
        this.setPipeline();
        // this.ref.detectChanges()
      }
      setTimeout(() => {
        this.loadingPipelines = false;
      }, 10);
    });

    this.loadProductDesigns();

    this.designSubscription = this.activeRoute.params.subscribe((params) => {
      if (!params || !params.id) {
        return;
      }
      this.productDesignSvc.getById(params.id).subscribe((resp) => {
        if (resp && resp.id) {
          if (resp.status > 0) {
            const modalRef = this.modal.open(NdViewCardPopupComponent, {
              size: 'lg',
            });
            modalRef.componentInstance.designCard = resp;
            modalRef.componentInstance.tabIndex = 0;
          } else {
            this.toastr.error('Card already deleted.', 'Error');
            this.router.navigate(['/quotes/new-designs'], { replaceUrl: true });
            // this.location.replaceState("/quotes/new-designs/");
          }
        }
        this.ref.detectChanges();
      });
    });
  }

  editdesign(design :any, i :number) {
    const modalRef = this.modal.open(NdPopupFormComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.design = design;
    modalRef.result.then(
      (newDesign :any) => {
        if (newDesign && newDesign.id) {
          const stage = this.activePipeline.stages[i];
          const idx = stage.records.findIndex((row) => row.id == newDesign.id);
          stage.records.splice(
            idx,
            1,
            Object.assign(stage.records[idx], newDesign),
          );

          this.computeStageCompletion(stage);

          this.ref.detectChanges();
        }
      },
      (_) => {},
    );
  }

  deletedesign(design :any, i :number) {
    Swal.fire({
      title: 'Confirm delete?',
      text: "Delete design '" + design.design_name + "'?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.translate.instant('BUTTONS.CONFIRM_DELETE_TEXT'),
    }).then((result) => {
      if (result.value) {
        this.productDesignSvc
          .deleteproductDesignPipeline(design.id)
          .subscribe((resp :any) => {
            const stage = this.activePipeline.stages[i];
            const idx = stage.records.findIndex((row) => row.id == design.id);
            stage.records.splice(idx, 1);
            this.ref.detectChanges();

            // console.log(resp);
            this.toastr.success('Successfully deleted design.', 'Success');
          });
      }
    });
  }

  moveToOtherPipeline(design :any, idx) {
    const modalRef = this.modal.open(NdPipelinePopupComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.design = design;
    modalRef.componentInstance.moveRfqToPipeline = 1;
    modalRef.result.then(
      (pipelines :any) => {
        design.pipelines = pipelines;
        if (pipelines && pipelines.length > 0) {
          const pipeline = pipelines.find(
            (row) => row.pipeline_id == this.activePipeline.id,
          );
          if (pipeline) {
            const stageIdx = this.activePipeline.stages.findIndex(
              (row) => row.id == pipeline.pipeline_stage_id,
            );
            design.priority = pipeline.priority;
            if (idx != stageIdx) {
              // add to new stage
              this.activePipeline.stages[stageIdx].recordsRaw.splice(0, 0, design);
              // this.activePipeline.stages[stageIdx].recordsRaw = this.orderBy.transform(this.activePipeline.stages[stageIdx].recordsRaw, ['-priority']);;
              // remove from existing stage
              const designIdx = this.activePipeline.stages[
                idx
              ].recordsRaw.findIndex((row) => row.id == design.id);
              this.activePipeline.stages[idx].recordsRaw.splice(designIdx, 1);
              this.filterStage(this.activePipeline.stages[stageIdx]);
              this.filterStage(this.activePipeline.stages[idx]);
            } else {
              // design.priority = pipeline.priority;
              const designIdx = this.activePipeline.stages[
                idx
              ].recordsRaw.findIndex((row) => row.id == design.id);
              this.activePipeline.stages[idx].recordsRaw.splice(
                designIdx,
                1,
                design,
              );
              // this.activePipeline.stages[idx].recordsRaw = this.orderBy.transform(this.activePipeline.stages[idx].recordsRaw, ['-priority']);;
              this.filterStage(this.activePipeline.stages[idx]);
            }
            this.ref.detectChanges();
          } else {
            const designIdx = this.activePipeline.stages[idx].recordsRaw.findIndex(
              (row) => row.id == design.id,
            );
            this.activePipeline.stages[idx].recordsRaw.splice(designIdx, 1);
            this.filterStage(this.activePipeline.stages[idx]);
            this.ref.detectChanges();
          }
        }
      },
      (_) => {},
    );
  }

  addToPipeline() {
    if (this.productDesign && this.productDesign.id && !this.addingDesign) {
      this.addingDesign = true;
      const payload :any = {
        product_design_id: this.productDesign.id,
        pipeline_stage_id: this.activePipeline.stages[0].id,
      };
      this.pipelineSvc
        .addProductDesignToPipeline(this.activePipeline.id, payload)
        .subscribe((resp :any) => {
          if (resp && resp.id) {
            const design = Object.assign({}, this.productDesign);
            this.activePipeline.stages[0].recordsRaw.splice(0, 0, design);
            this.activePipeline.stages[0].records.splice(0, 0, design);
            // this.activePipeline.stages[0].records.splice(0,0,resp);
            this.addingDesign = false;
            this.productDesign = null;
            this.ref.detectChanges();
          }
        });
    }
  }

  setMasterPipeline() {
    if (!this.filter.masterPipelineId) {
      return;
    }
    this.activeMasterPipeline = this.masterPipelines.find(
      (row) => row.id == this.filter.masterPipelineId,
    );

    if (!this.activeMasterPipeline && this.masterPipelines.length > 0) {
      this.activeMasterPipeline = this.masterPipelines[0];
      this.filter.masterPipelineId = this.activeMasterPipeline.id;
    }

    if (!this.activeMasterPipeline) {
      return;
    }

    if (!this.activeMasterPipeline.child_pipelines.length) {
      this.filter.pipelineId = 0;
      this.activePipeline = null;
    } else {
      const pipeline = this.activeMasterPipeline.child_pipelines.find(
        (row) => row.pipeline_id == this.filter.pipelineId,
      );
      if (!pipeline) {
        this.filter.pipelineId = 0;
        this.activePipeline = null;
      }
    }

    this.changePipeline.emit(this.activeMasterPipeline);
    this.pipelineFilter = { ...this.filter };
    this.uiStateSvc.setState('design-sku-pipelines', this.filter);
  }

  setActivePipeline(pipelineId) {
    this.filter.pipelineId = pipelineId;
    this.setPipeline();
  }

  setMasterPipelineCompletion(completionStatusEvent) {
    if (this.activeMasterPipeline) {
      this.activeMasterPipeline.completionStatus = completionStatusEvent;
    }
  }

  setPipeline() {
    if (!this.filter.pipelineId || this.filter.pipelineId == 0) {
      if (this.masterPipelines.length > 0) {
        this.activePipeline = null;
        this.setMasterPipeline();

        return;
      }
    }

    this.activePipeline = this.pipelines.find(
      (row) => row.id == this.filter.pipelineId,
    );

    if (!this.activePipeline) {
      this.activePipeline = this.pipelines[0];
      this.filter.pipelineId = this.activePipeline.id;
      // return;
    }

    this.changePipeline.emit(this.activePipeline);

    this.activePipeline.stages = this.orderBy.transform(
      this.activePipeline.stages,
      ['order'],
    );

    this.activePipeline.stages.forEach((stage) => {
      stage.loading = true;

      this.filter = Object.entries(this.filter).reduce(
        (a, [k, v]) => (v ? ((a[k] = v), a) : a),
        {},
      );

      let params = {
        all: 1,
        pipeline_id: this.activePipeline.id,
        pipeline_stage_id: stage.id,
        ...this.filter,
      };
      delete params.pipelineId;

      Object.keys(this.filter).forEach((e) => {
        if (
          ['assigned_tags', 'category_id', 'subcategory_id', 'assignee'].includes(e)
        ) {
          params[e] = this.filter[e].join(',');
        }
      });

      params = Object.entries(params).reduce(
        (a, [k, v]) => (v ? ((a[k] = v), a) : a),
        {},
      ); // remove falsy filter values

      this.subscriptions.push(
        this.productDesignSvc.getAsync(params).subscribe((designs) => {
          stage.records = designs.map((row) => {
            return {
              ...row,
              attachments_count: row.attachments.length,
            };
          });
          stage.recordsRaw = stage.records;

          stage.count = stage.records.length;
          this.filterStage(stage);
          stage.tags = [];
          if (stage.tag_ids) {
            stage.tags = this.activePipeline.tags.filter(
              (row) => stage.tag_ids.indexOf(row.id) >= 0,
            );
          }

          try {
            stage.owners = JSON.parse(stage.owners);
          } catch (e) {}

          stage.assignees = [];
          if (stage.owners && Array.isArray(stage.owners)) {
            stage.assignees = this.staff.filter(
              (row) => stage.owners.indexOf(row.id) >= 0,
            );
          }

          // compute for stage completion status
          this.computeStageCompletion(stage);

          stage.loading = false;
          this.ref.detectChanges();
        }),
      );
    });
    this.uiStateSvc.setState('design-sku-pipelines', this.filter);
    // this.getRecords();
  }

  // compute for pipeline completion status
  computePipelineCompletion() {
    const status :any = {
      total: 0,
      completed: 0,
    };
    this.activePipeline.stages.forEach((stage :any) => {
      status.total += stage.completionStatus ? stage.completionStatus.total : 0;
      status.completed += stage.completionStatus
        ? stage.completionStatus.completed
        : 0;
    });
    this.activePipeline.completionStatus = status;
  }

  // compute for pipeline stage completion status
  computeStageCompletion(stage :any) {
    // set to count for complete status of this stage
    stage.completionStatus = {
      total: 0,
      completed: 0,
    };
    stage.records.forEach((record :any) => {
      if (!record.assigned_subtasks || record.assigned_subtasks.length == 0) {
        stage.completionStatus.total += 1;
        stage.completionStatus.completed += record.mark_as_completed ? 1 : 0;
      } else {
        stage.completionStatus.total += record.assigned_subtasks.length;
        stage.completionStatus.completed += record.mark_as_completed
          ? record.assigned_subtasks.length
          : record.assigned_subtasks.filter((row) => row.done).length;
      }
    });
    this.computePipelineCompletion();
  }

  markAsCompleted(design :any, i :number) {
    const data = {
      mark_as_completed: design.mark_as_completed,
      design_name: design.design_name,
    };

    this.productDesignSvc.markAsCompleted(design.id, data).subscribe(
      (resp) => {},
      (err) => {},
    );
    const stage = this.activePipeline.stages[i];
    this.computeStageCompletion(stage);
  }

  isDesignCompleted(markAsCompleted) {
    return markAsCompleted;
  }

  isDesignDue(dueDate :Date, markAsCompleted) {
    if (markAsCompleted) {
      return false;
    }
    const today :Date = new Date();
    const dateDue :Date = new Date(dueDate);

    return today >= dateDue;
  }

  isDesignSubtaskCompleted(subtasks) {
    let completed = true;

    subtasks.map((subtask, i) => {
      if (subtask.done) {
        completed = true;
      } else {
        completed = false;
      }
    });

    return completed;
  }

  checkCompleteSubtask(subtasks) {
    let count = 0;

    subtasks.map((subtask, i) => {
      if (subtask.done) {
        count++;
      }
    });

    return count;
  }

  toggleTag(tagId, activePipeline) {
    if (!activePipeline.tag_ids) {
      activePipeline.tag_ids = [tagId];
    } else {
      const idx = activePipeline.tag_ids.indexOf(tagId);
      if (idx >= 0) {
        activePipeline.tag_ids.splice(idx, 1);
      } else {
        activePipeline.tag_ids.push(tagId);
      }
    }
    this.productDesignSvc
      .updateDesignPipelineStage(
        activePipeline.product_design_id,
        this.activePipeline.id,
        { tag_ids: activePipeline.tag_ids },
      )
      .subscribe();
  }

  getRecords() {
    this.activePipeline.stages.forEach((stage) => {
      this.filterStage(stage);
    });
  }

  isTagActive(tagId, designPipelineTagIds) {
    if (!designPipelineTagIds || designPipelineTagIds.length == 0) {
      return false;
    }

    return designPipelineTagIds.indexOf(tagId) >= 0;
  }

  filterStage(stage :any) {
    const records = stage.recordsRaw;
    // if (this.filter.design_name) {
    // 	records = this.filterBy.transform(records, ['design_name'], this.filter.design_name)
    // }
    // if (this.filter.sku) {
    // 	records = this.filterBy.transform(records, ['sku'], this.filter.sku)
    // }
    // if (this.filter.date) {
    // 	records = this.filterBy.transform(records, ['created_at'], this.datePipe.transform(this.filter.date, 'yyyy-MM-dd'));
    // }

    let sortOrderSet :boolean = false;

    records.forEach((record) => {
      if (record.pipelines) {
        record.activePipeline = record.pipelines.find(
          (row) => row.pipeline_stage_id == stage.id,
        );
        // record.priority = record.activePipeline.priority;
        // record.attachments = JSON.parse(record.attachments);
        // record.priority = record.activePipeline.priority;
        record.attachments = record.attachments;

        record.attachments.forEach((row :any) => {
          const file_name_string = row.name;
          const file_name_array = file_name_string.split('.');
          const file_extension = file_name_array[file_name_array.length - 1];

          if (this.valid_format.indexOf(file_extension.toLowerCase()) != -1) {
            record.attachment = this.url + '/file?f=' + row.filename;
          }

          // if (row.type && row.type.indexOf("image") != -1) {
          // 	// console.log(record.attachments);
          // 	record.attachment = this.url + "/file?f=" + row.filename;
          // }
        });

        const designPipeline = record.pipelines.find(
          (row) =>
            row.pipeline_stage_id == stage.id && row.product_design_id == record.id,
        );
        record.order = designPipeline.order;
        record.priority = designPipeline.priority;
        if (record.order > 0) {
          sortOrderSet = true;
        }
        // record.order = record.order ? record.order : record.priority * -1;
      }
      // console.log(record.attachment);
    });
    if (!sortOrderSet) {
      this.sortStage(stage);
    } else {
      stage.records = this.orderBy.transform(records, ['order']);
    }
    //
  }

  sortStage(stage, sortBy ?:string) {
    if (sortBy === 'priority') {
      stage.records = stage.records.sort(function (a :any, b :any) {
        if (a.design_priority === '' || a.design_priority === null) return 1;
        if (b.design_priority === '' || b.design_priority === null) return -1;

        return b.design_priority - a.design_priority;
      });
      // stage.records = this.orderBy.transform(stage.records, ["-design_priority"]);
    } else if (sortBy === 'due_date') {
      stage.records = stage.records.sort(function (a :any, b :any) {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        if (a.due_date === '' || a.due_date === null) return 1;
        if (b.due_date === '' || b.due_date === null) return -1;

        return new Date(a.due_date).valueOf() - new Date(b.due_date).valueOf();
      });
    } else {
      return;
    }

    const designIds :any[] = [];
    stage.records.forEach((row, idx) => {
      row.order = idx + 1;
      designIds.push({ id: row.id, order: row.order });
      // this.productDesignSvc.updateDesignPipelineStage(row.id, this.activePipeline.id, { order: idx + 1 }).subscribe();
    });
    stage.records = this.orderBy.transform(stage.records, ['order']);
    if (designIds.length > 0) {
      this.pipelineSvc
        .updatePipelineStageSortOrder(this.activePipeline.id, stage.id, designIds)
        .subscribe();
    }
  }

  drop(event :CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
      const stage = this.activePipeline.stages[event.container.id];
      if (event.previousIndex > event.currentIndex) {
        const designIds :any = stage.records
          .filter(
            (row) =>
              row.order > event.currentIndex && row.order <= event.previousIndex,
          )
          .map((row :any) => {
            row.order += 1;

            return { id: row.id, order: row.order };
          });
        designIds.push({
          id: event.item.data.id,
          order: event.currentIndex + 1,
        });
        if (designIds.length > 0) {
          this.pipelineSvc
            .updatePipelineStageSortOrder(
              this.activePipeline.id,
              stage.id,
              designIds,
            )
            .subscribe();
        }
      } else if (event.previousIndex < event.currentIndex) {
        const designIds :any = stage.records
          .filter(
            (row) =>
              row.order <= event.currentIndex && row.order > event.previousIndex,
          )
          .map((row :any) => {
            row.order += 1;

            return { id: row.id, order: row.order };
          });
        designIds.push({
          id: event.item.data.id,
          order: event.currentIndex + 1,
        });
        if (designIds.length > 0) {
          this.pipelineSvc
            .updatePipelineStageSortOrder(
              this.activePipeline.id,
              stage.id,
              designIds,
            )
            .subscribe();
        }
      }
    } else {
      const design :any = event.item.data;
      const payload :any = {
        product_design_id: design.id,
        pipeline_id: event.item.data.pipeline_id,
        pipeline_stage_id: this.activePipeline.stages[event.container.id].id,
      };
      // update stage for the card/design
      this.productDesignSvc
        .updateDesignPipelineStage(design.id, this.activePipeline.id, payload)
        .subscribe(() => {
          // update new stage orders
          const stage = this.activePipeline.stages[event.container.id];
          const designIds :any = stage.records
            .filter((row) => row.order > event.currentIndex)
            .map((row :any) => {
              row.order += 1;

              return { id: row.id, order: row.order };
            });
          event.item.data.order = event.currentIndex + 1;
          designIds.push({
            id: event.item.data.id,
            order: event.currentIndex + 1,
          });
          if (designIds.length > 0) {
            this.pipelineSvc
              .updatePipelineStageSortOrder(
                this.activePipeline.id,
                stage.id,
                designIds,
              )
              .subscribe();
          }
        });

      this.activePipeline.stages[event.container.id].count += 1;
      this.activePipeline.stages[event.previousContainer.id].count -= 1;

      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  showDetails(design :any, i :number, tabIndex :number = 0) {
    // this.router.navigate(["/quotes", "new-designs", design.id, "view"]);
    const modalRef = this.modal.open(NdViewCardPopupComponent, { size: 'lg' });
    modalRef.componentInstance.designCard = design;
    modalRef.componentInstance.tabIndex = tabIndex;

    modalRef.result.then(
      (result :any) => {
        if (result.method && result.method == 'delete') {
          const stage = this.activePipeline.stages[i];
          const idx = stage.records.findIndex((row) => row.id == result.design.id);
          stage.records.splice(idx, 1);
          this.ref.detectChanges();

          return;
        }

        if (result && result.id) {
          const stage = this.activePipeline.stages[i];
          const idx = stage.records.findIndex((row) => row.id == result.id);
          stage.records.splice(idx, 1, Object.assign(stage.records[idx], result));
          this.ref.detectChanges();
        }
      },
      (_) => {},
    );

    // window.open('/quotes/new-designs/' + design.id + '/view');
  }

  mySalesClient(userAccount) {
    if (!userAccount.go_team_member) {
      return false;
    }

    return userAccount.go_team_member.find((row) => {
      return row.staff_id == this.authService.loginUser.id;
    })
      ? true
      : false;
  }

  resetFields() {
    const pipelineId = this.filter.pipelineId;
    const masterPipelineId = this.filter.masterPipelineId;

    this.filter = {};
    delete this.filter.date;
    delete this.filter.sku;
    delete this.filter.design_name;
    this.uiStateSvc.setState('design-sku-pipelines', this.filter);

    this.filter.pipelineId = pipelineId;
    this.filter.masterPipelineId = masterPipelineId;
    this.pipelineFilter = { ...this.filter };
    this.setPipeline();
  }

  trackByFn(item :any) {
    return item.id;
  }

  private loadProductDesigns() {
    this.productDesigns$ = concat(
      of([]), // default items
      this.designInput$.pipe(
        filter((res) => {
          return res !== null && res.length >= this.minLengthTerm;
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => (this.designLoading = true)),
        switchMap((term) =>
          this.productDesignSvc.search({ keyword: term }).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.designLoading = false)),
            map((resp) => resp.data),
          ),
        ),
      ),
    );
  }

  customTagsSearchFn(term :any, item :any) {
    term = term.toLocaleLowerCase();

    return item.name
      .toLowerCase()
      .replace(/&nbsp;/gi, '')
      .includes(term);
  }

  getRecordTimeout() {
    setTimeout(() => {
      this.getRecords();
    }, 10);
  }

  getPriority(design) {
    return design.design_priority;

    const currentPipepline = design.pipelines.filter(
      (pipeline) => pipeline.pipeline_id === this.activePipeline.id,
    )[0];

    return currentPipepline.priority;
  }

  abilityToDelete(design) {
    if (this.authService.loginUser.role == 99) {
      return true;
    }
    if (design.created_by == null) {
      return false;
    }
    if (design.created_by.id == this.authService.loginUser.id) {
      return true;
    } else {
      return false;
    }
  }

  markSubtaskAsCompleted(design :any, index :number, stage :any) {
    const stageIndex = this.activePipeline.stages.findIndex(
      (e) => e.id === stage.id,
    );
    const designIndex = this.activePipeline.stages[stageIndex].records.findIndex(
      (e) => e.id === design.id,
    );
    const subtask =
      this.activePipeline.stages[stageIndex].records[designIndex].assigned_subtasks[
        index
      ];

    const payload = { done: !subtask.done, id: subtask.id };

    this.subtaskSvc.toggleCheckSubtask(design.id, subtask.id, payload).subscribe(
      (resp) => {
        this.activePipeline.stages[stageIndex].records[
          designIndex
        ].assigned_subtasks[index].done = payload.done;
        this.ref.detectChanges();
      },
      (err) => {},
    );
  }

  calculateDateDiff(dateCreated) {
    const currentDate = new Date();
    const dateSent = new Date(dateCreated);

    const days = Math.floor(
      (Date.UTC(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate(),
      ) -
        Date.UTC(dateSent.getFullYear(), dateSent.getMonth(), dateSent.getDate())) /
        (1000 * 60 * 60 * 24),
    );

    return days;
  }
}
